import { CommApiInstance } from "Utils/CommApiInstance";

const GameSsoCallBackApi = async (
    referrer:string          ,
    code:string|null         ,
    naverState:string|null   ,
    gameSvcCd:string|null    ,
    redirectUri:string|null  ,
) => {
    if(referrer =="naver") {
        return await CommApiInstance.post(`/game/${gameSvcCd}/login_web/callback/${referrer}`,{
            apiBody:{
                oauth2Tkn:code,
                state:naverState,
                redirectUri:redirectUri
            },
        })
        .then((Resp) => Resp.data);
    }else {
        return await CommApiInstance.post(`/game/${gameSvcCd}/login_web/callback/${referrer}`,{
            apiBody:{
                oauth2Tkn:code,
                redirectUri:redirectUri
            },
        })
        .then((Resp) => Resp.data);
    }
}
export default GameSsoCallBackApi;